import React from 'react';
import Helmet from 'react-helmet';
import { useHistory, useParams } from 'react-router-dom';
import styled from '@emotion/styled';

import Layout from '../../shared/components/Layout/Layout';
import Icon from '../../shared/_TBComponents/Icon';
import Text from '../../shared/_TBComponents/Text';
import HistoryGoalBlock from './components/presentational/HistoryGoalBlock';
import CurrentMaxCard from './components/presentational/CurrentMaxCard';
import HistorySectionHeader from './components/presentational/HistorySectionHeader';
import MaxHistoryChart from './components/presentational/MaxHistoryChart';
import MaxHistoryTable from './components/presentational/tables/MaxHistoryTable';
import AddMaxesModal from './modals/AddMaxesModal';
import ConfirmActionModal from './modals/ConfirmActionModal';
import SetGoalModal from './modals/SetGoalModal';
import useMaxHistory from './hooks/useMaxHistory';

const MAXES_GOALS_PATH = '/maxes-goals';

const PageWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  height: calc(100% - 49px);
  margin-top: 49px;
  padding: 16px;
  overflow: scroll;
  background: #F5F5F5;
`;

const TopCards = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(320px, 1fr));
  gap: 16px;
`;

const BackButton = styled.button`
  display: flex;
  align-items: center;
  align-self: flex-start;
  gap: 6px;
  padding: 0;
  border: none;
  background: none;
  font-family: inherit;
  font-size: 16px;
  font-weight: 700;
  color: #77A7FF;
  cursor: pointer;
`;

const MaxHistory = () => {
  const history = useHistory();
  const params = useParams();
  const {
    title, currentMaxProps, historyHeaderProps, goalBlockProps, chartProps, tableProps,
    confirmProps, addRecordProps, setGoalProps,
  } = useMaxHistory(Number(params.userId), Number(params.exerciseId));

  const handleBack = () => history.push(MAXES_GOALS_PATH);

  return (
    <Layout fullWidth>
      <Helmet>
        <title>Max History | TeamBuildr</title>
      </Helmet>
      <PageWrapper>
        <BackButton type='button' onClick={handleBack}>
          <Icon icon='left-arrow' size={12} color='#77A7FF' />
          Back to Maxes & Goals
        </BackButton>
        <Text styledTextProps={{ fontSize: '20px', fontWeight: 700 }}>{title}</Text>
        <TopCards>
          <CurrentMaxCard {...currentMaxProps} />
          <HistoryGoalBlock {...goalBlockProps} />
        </TopCards>
        <HistorySectionHeader {...historyHeaderProps} />
        {chartProps && <MaxHistoryChart {...chartProps} />}
        <MaxHistoryTable {...tableProps} />
      </PageWrapper>
      <ConfirmActionModal {...confirmProps} />
      <AddMaxesModal {...addRecordProps} />
      <SetGoalModal {...setGoalProps} />
    </Layout>
  );
};

export default MaxHistory;
